module.exports = __webpack_public_path__ + "static/media/Terri_AEng_s1.9b03f3b3.mp3";